module.exports = __webpack_public_path__ + "img/huawei-3.24d2cb92.png";